import {observer} from "mobx-react";
import {HolderNaturalForm} from "./HolderNaturalForm";
import {HolderLegalForm} from "./HolderLegalForm";
import {registrationStore} from "../../../../../store";
import {HolderAssociationForm} from "./HolderAssociationForm";
import {HolderDtoPersonTypeEnum} from "../../../../../api";

const HolderPanel = observer(function HolderPanel() {
    return <>
        <nav className="panel">
            <p className="panel-heading">Halter</p>
            <div className="panel-block">
                <div>
                    <div className="tabs" style={{
                        marginLeft: '-1em',
                        marginTop: '-0.75em',
                        marginRight: '-1em',
                    }}>
                        <ul>
                            <li className={`${registrationStore.personType === HolderDtoPersonTypeEnum.NATURAL ? 'is-active' : ''}`}><a href={'/#'} onClick={(e) => {
                                e.preventDefault()
                                registrationStore.personType = HolderDtoPersonTypeEnum.NATURAL
                            }}>Natürliche Person</a></li>
                            <li className={`${registrationStore.personType === HolderDtoPersonTypeEnum.LEGAL ? 'is-active' : ''}`}><a href={'/#'} onClick={(e) => {
                                e.preventDefault()
                                registrationStore.personType = HolderDtoPersonTypeEnum.LEGAL
                            }}>Juristische Person</a></li>
                            <li className={`${registrationStore.personType === HolderDtoPersonTypeEnum.ASSOCIATION ? 'is-active' : ''}`}><a href={'/#'} onClick={(e) => {
                                e.preventDefault()
                                registrationStore.personType = HolderDtoPersonTypeEnum.ASSOCIATION
                            }}>Vereinigung</a></li>
                        </ul>
                    </div>

                    {registrationStore.personType === HolderDtoPersonTypeEnum.NATURAL && <HolderNaturalForm />}
                    {registrationStore.personType === HolderDtoPersonTypeEnum.LEGAL && <HolderLegalForm />}
                    {registrationStore.personType === HolderDtoPersonTypeEnum.ASSOCIATION && <HolderAssociationForm />}
                </div>
            </div>
        </nav>
    </>
})

export {
    HolderPanel
}
